import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams, useLocation } from 'react-router-dom';

import { Accordion } from './styles';
import VideoQuestions from '../video-questions';

const QuestionVideoAnswerTranscriptPlaylist = (props) => {
  const { transcribedAnswers, question, onSubmit } = props;

  const { projectId } = useParams();
  const location = useLocation();
  const history = useHistory();

  const [videoSelected, setVideoSelected] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const videoId = queryParams.get('videoId');
    if (videoId) {
      setVideoSelected(videoId);
    }
  }, [location.search]);

  const handleSelectVideo = useCallback((id) => {
    history.push(`/projects/${projectId}/videos/questions/${question.id}?videoId=${id}`);
    setVideoSelected(id);
  }, [history, question.id, projectId]);

  return (
    <Accordion exclusive={false}>
      {transcribedAnswers.map(({
        user,
        answer,
        videoId,
        index,
      }) => (
        <VideoQuestions
          key={answer.id}
          user={user}
          question={question}
          index={index}
          answer={answer}
          onSubmit={onSubmit}
          onClick={() => handleSelectVideo(videoId)}
          isVideoPlaying={videoSelected === videoId}
        />
      ))}
    </Accordion>
  );
};

QuestionVideoAnswerTranscriptPlaylist.propTypes = {
  transcribedAnswers: PropTypes.arrayOf(
    PropTypes.shape({
      user: PropTypes.shape({}),
      answer: PropTypes.shape({}),
      index: PropTypes.number,
    }),
  ).isRequired,
  question: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func,
};

QuestionVideoAnswerTranscriptPlaylist.defaultProps = {
  onSubmit: () => { },
};

export default QuestionVideoAnswerTranscriptPlaylist;
